import React, { useEffect, useRef } from "react";
import { useInstitutions } from "@/features/institutions/hooks/use-institutions";
import { SearchCodeType } from "@/shared/config/globals";
import { SearchCodeButtons } from "@/features/institutions/components/search-code-buttons";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";


interface Props {
  onSelectInstitution: () => void;
}

export const InstitutionsListBox = (props: Props) => {
  const {
    onSelectInstitution,
  } = props;

  const {
    institutionType,
    institutions,
    setSelectedInstitution,
  } = useInstitutionsContext();

  const {
    currentSearchCode,
    setCurrentSearchCode,
    showInstitutions,
    getInstitutions,
    filterInstitutionsBySearchCode,
  } = useInstitutions();

  // 頭文字ボタン押下時の処理
  const handleSearchCodeClick = (code: SearchCodeType) => {
    // 同じ頭文字を再度押した場合は全件表示に戻す
    if (currentSearchCode === code) {
      setCurrentSearchCode(undefined);
    } else {
      setCurrentSearchCode(code);
    }
  };

  useEffect(() => {
    if (institutionType) {
      getInstitutions(institutionType);
    }
  }, [institutionType]);

  const listRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    filterInstitutionsBySearchCode();
  }, [currentSearchCode, institutions]);

  // 50音選択後、リスト先頭の金融機関にフォーカス
  useEffect(() => {
    if (currentSearchCode && listRef.current) {
      const firstButton = listRef.current.querySelector<HTMLElement>("button");
      if (firstButton) firstButton.focus();
    }
  }, [showInstitutions]);

  return (
    <>
      <div className="key-kana" style={{alignItems: "flex-start"}}>
        {/* 頭文字ボタンをここに配置 */}
        <SearchCodeButtons
          onClick={handleSearchCodeClick}
          selectedCode={currentSearchCode}
          onFocusOutRight={() => {
            const firstButton = listRef.current?.querySelector<HTMLElement>("button");
            firstButton?.focus();
          }}
        />
        {/* 金融機関一覧 */}
        <ul
          ref={listRef}
          className="fc-list"
          style={{ height: "31rem", overflowY: "auto" }}
          onKeyDown={(e) => {
            if (e.key === "ArrowLeft") {
              e.preventDefault();
              // 50音表の「ア」へフォーカスを戻す
              const aInput = document.getElementById("item-a") as HTMLInputElement | null;
              aInput?.focus();
            }
          }}
        >
          {showInstitutions.map((institution) => (
            <li key={`${institution.companyCode}-${institution.branchCode || ""}`}>
              <button
                onClick={() => {
                  setSelectedInstitution(institution);
                  onSelectInstitution();
                  // props.onConfirm(institution);
                }}
              >
                {institution.companyName}
              </button>
            </li>
          ))}
        </ul>
      </div>
      <ul>
        <li>JAバンク/JFバンクの場合は、JA/JF以降の読み仮名で検索されます。</li>
        <li>表示されない金融機関には、現在対応しておりません。</li>
      </ul>
    </>
  );
};
